Number.prototype.inRange = function(a, b) { // TODO not as extension
  const min = Math.min.apply(Math, [a, b])
  const max = Math.max.apply(Math, [a, b])
  return this >= min && this <= max
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

function prepareTextForParsing(text) {
  //works with maximum 10, otherwise the indices will change
  const replacements = [/[äà]/g, /[öò]/g, /[üù]/g, 'ß', '\\-', /[()]/g,]

  replacements.forEach((r, index) => {
    text = text.replace(typeof r === 'string' ? new RegExp(r, 'g') : r, '' + index)
  })
  return text
}

exports.ReferenceTool = {
  parseWords(text, parserMapping, selfref) {
    //todo use custom regex without word boundary \b
    if (!text || !text.text) {
      return text
    }

    const prepText = prepareTextForParsing(text.text)

    parserMapping.forEach(ref => {
      const prepWord = prepareTextForParsing(ref.text)
      const wordLength = prepWord.length
      let flags='gu'
      if(!ref.caseSensitive){
        flags += 'i'
      }
      const re = new RegExp(`(\\b|\\b[0-9])${escapeRegExp(prepWord)}(\\b|\\.|[0-9]\\b)`, flags)
      let match
      while ((match = re.exec(prepText)) != null) {
        const offset = match[1].length
        const start = match.index + offset
        const end = start + wordLength
        const type = ref.ref === selfref ? 'selfref' : 'crossref'

        const isAlreadyLinked = text.spans.find(s => ['selfref', 'crossref'].includes(s.type) &&
          (start.inRange(s.start, s.end) || end.inRange(s.start, s.end)))

        const lang = text.lang === "en" ? "en-gb" : "de-de" // TODO language via config
        if (!isAlreadyLinked && lang === ref.lang) {
          text.spans.push({
            start,
            end,
            type,
            data: {to: ref.ref, lang: ref.lang}
          })
        }

      }
    })
  }
}


